import styled from 'styled-components';

export const Container = styled.div``;

export const Info = styled.main`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  place-content: center;

  align-items: center;
  justify-items: center;

  h1 {
    width: 100vw;

    text-align: center;

    margin-top: 24px;
    color: #2c73e9;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-wrap: wrap;

  place-content: center;

  align-items: center;
  justify-items: center;
  margin: 24px auto;

  button {
    margin: 6px 8px;
    width: 350px;
    padding: 8px;
  }
`;
